import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'resume-last-alert-table',
  templateUrl: './resume-last-alert-table.component.html',
  styleUrls: ['./resume-last-alert-table.component.scss']
})
export class ResumeLastAlertTableComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
